module.exports = __webpack_public_path__ + "img/qrcode.eb6a03e3.jpg";